// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_3fk3JRXDfy3s8jc8aICM7I"};